function filter01() {
    return [
        {
            fieldName: 'id',
            type: "value",
            value: 1
        }
    ]
}
function filterRows() {
    return [
        {
            fieldName: 'idCustomerOrder',
            type: "value",
            value: localStorage.getItem('idCustomerOrder')
        }
    ]
}
export const customFilters = {
    filter01: filter01,
    filterRows: filterRows
};